<template>
    <div class="row">
         <div class="col-md-6 mb-1">
            <label class="form-label">Yük Adı</label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name">
                <input type="text" class="form-control" placeholder="Yük Adı" v-model="value.Name"/>
            </v-validator>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Yük Grubu</label>
            <v-validator :errors="errors" parameter="ShipableProductSubGroupId" :watch="shipableProductSubGroup">
                <v-select-list :disabled="editing" v-model="shipableProductSubGroup" label="Name" placeholder="Yük Grubu" :options="shipableProductSubGroups"/>
            </v-validator>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Ölçü Birimi</label>
            <v-validator :errors="errors" parameter="MeasurementUnitId" :watch="meausurementUnit">
                <v-select-list v-model="meausurementUnit" label="Name" placeholder="Ölçü Birimi" :options="meausurementUnits"/>
            </v-validator>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Yük Şekli</label>
            <v-validator :errors="errors" parameter="ShipableProductFormIds" :watch="vehicleFormIds">
                <v-select-list multiple v-model="vehicleFormIds" label="Name" placeholder="Yük Şekli" :options="forms"/>
            </v-validator>
        </div>
        <div class="col-md-3 mb-1">
            <label class="form-label">Çap (M)</label>
            <v-validator :errors="errors" parameter="Diameter" :watch="value.Diameter">
                 <input type="text" class="form-control" placeholder="Çap (M)" v-model="value.Diameter"/>
            </v-validator>
        </div>
        <div class="col-md-3 mb-1">
            <label class="form-label">Yükseklik (M)</label>
            <v-validator :errors="errors" parameter="Height" :watch="value.Height">
                 <input type="text" class="form-control" placeholder="Yükseklik (M)" v-model="value.Height"/>
            </v-validator>
        </div>
        <div class="col-md-3 mb-1">
            <label class="form-label">Genişlik (M)</label>
            <v-validator :errors="errors" parameter="Width" :watch="value.Width">
                 <input type="text" class="form-control" placeholder="Genişlik (M)" v-model="value.Width"/>
            </v-validator>
        </div>
        <div class="col-md-3 mb-1">
            <label class="form-label">Uzunluk (M)</label>
            <v-validator :errors="errors" parameter="Length" :watch="value.Length">
                 <input type="text" class="form-control" placeholder="Uzunluk (M)" v-model="value.Length"/>
            </v-validator>
        </div>
        <div class="col-md-3 mb-1">
            <label class="form-label">Kıymet Sınıfı</label>
            <v-validator :errors="errors" parameter="ShipableProductValueClassId" :watch="shipableProductValueClass">
              <v-select-list v-model="shipableProductValueClass" label="Name" placeholder="Kıymet Sınıfı" :options="shipableProductValueClasses"/>
            </v-validator>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Tehlike Sınıfı</label>
            <v-validator :errors="errors" parameter="ShipableProductDangerClassId" :watch="shipableProductDangerClass">
                 <v-select-list v-model="shipableProductDangerClass" label="Name" placeholder="Tehlike Sınıfı" :options="shipableProductDangerClasses"/>
            </v-validator>
        </div>
    </div>
</template>

<script>
import ShipableProductApi from '@/api/shipable-product'
import SystemDataApi from '@/api/system-data'
export default {
    props:{
        value:Object,
        errors:Object,
        editing:Boolean
    },
    components:{
    },
    mounted(){
        this.getMeausurementUnits();
        this.getShipableProductSubGroups();
        this.getShipableProductDangerClasses();
        this.getShipableProductValueClasses();
        this.getShipableProductForms();
    },
    data(){
        return{
            meausurementUnits:[],
            shipableProductSubGroups:[],
            shipableProductValueClasses:[],
            shipableProductDangerClasses:[],
            forms:[],
        }
    },
    methods:{
        getShipableProductForms(){
            ShipableProductApi.Form.List()
            .then(res=>{
                this.forms = res.data.Data
            })
        },
        getMeausurementUnits(){
            SystemDataApi.MeauserementUnit()
            .then(res=>{
                this.meausurementUnits = res.data.Data
            })
        },
        getShipableProductSubGroups(){
            ShipableProductApi.SubGroup.List()
            .then(res=>{
                this.shipableProductSubGroups = res.data.Data
            })
        },
        getShipableProductDangerClasses(){
            ShipableProductApi.DangerClass.List()
            .then(res=>{
                this.shipableProductDangerClasses = res.data.Data
            })
        },
        getShipableProductValueClasses(){
            ShipableProductApi.ValueClass.List()
            .then(res=>{
                this.shipableProductValueClasses = res.data.Data
            })
        }
    },
    computed:{
        meausurementUnit:{
            get:function(){
                return this.meausurementUnits.find(b=>b.Id==this.value.MeasurementUnitId)
            },
            set:function(value){
                this.value.MeasurementUnitId = value?.Id || this.value.MeasurementUnitId
            }
        },
        shipableProductSubGroup:{
            get:function(){
                return this.shipableProductSubGroups.find(b=>b.Id==this.value.ShipableProductSubGroupId)
            },
            set:function(value){
                this.value.ShipableProductSubGroupId = value?.Id || this.value.ShipableProductSubGroupId
            }
        },
        shipableProductValueClass:{
            get:function(){
                return this.shipableProductValueClasses.find(b=>b.Id==this.value.ShipableProductValueClassId)
            },
            set:function(value){
                this.value.ShipableProductValueClassId = value?.Id || this.value.ShipableProductValueClassId
            }
        },
        shipableProductDangerClass:{
            get:function(){
                return this.shipableProductDangerClasses.find(b=>b.Id==this.value.ShipableProductDangerClassId)
            },
            set:function(value){
                this.value.ShipableProductDangerClassId = value?.Id || this.value.ShipableProductDangerClassId
            }
        },
        vehicleFormIds:{
            get:function(){
                return this.forms.filter(f=> this.value.ShipableProductFormIds.includes(f.Id))
            },
            set:function(value){
                this.value.ShipableProductFormIds = value?.map(v=> v?.Id) || this.value.ShipableProductFormIds
            }
        }
    }
}
</script>

<style lang="scss">
</style>